{
  "image_not_found": "Image no trouvée",
  "show_completed": "TODO:",
  "wrong_email_error": "TODO:",
  "wrong_phone_error": "TODO:",
  "fieldMin": "TODO: {{min}}",
  "fieldMax": "TODO: {{max}}",
  "enter_at_least_phone": "TODO:",
  "enter_at_least_email": "TODO:"
}
